import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import closeIcon from "assets/icons/close-outline.svg";
import {
  updateUserInfo,
  updateUserAvatarStart,
  unblockUserStart,
} from "../../../redux/chats/chats.actions";
import clsx from "clsx";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import useTranslation from "hooks/useTranslation";
import { isValidMobile, verifyFileToOpen } from "utils/validation.js";
import ProgressBar from "components/ProgressBar";
import UserAvatar from "../UserAvatar";
import styles from "./styles.module.scss";
import useMediaQuery from "use-mediaquery";
import BlockUserModal from "../AcceptRejectConv/components/BlockUserModal";
import {
  BlockConversationIconComponent,
  EditIconComponent,
  NoteIcon,
} from "assets/icons";
import { getEmailValue } from "utils/email";
import {
  getFormatedTotalFromTimeElapsedObject,
  getTotalElapsedTimeInMs,
} from "components/UserRoadmap/components/Utils";
import { getElapsedTime } from "utils/date";
import ConfirmModal from "components/Modals/ConfirmModal";
import { isValidEmail } from "utils/validation.js";
import { toast } from "react-toastify";
import { getDecodedURL } from "utils/url";
import UserDetailsBox from "./components/UserDetailsBox";
import EditingField from "./components/EditingField";
import ContentField from "./components/ContentField";

const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;
const getAgent = ({ userData }) => userData.agent.data;
const getAgents = ({ userData }) => userData.agents.data;
const getContainer = ({ userData }) => userData.container.data;
const getData = ({ roadmapData }) => roadmapData.roadmap.data;
const getAllTeams = ({ chatsData }) => chatsData.teams.allTeams;

const USER_NOTE_ELEMENT_MAX_HEIGHT = 240;
const ALLOWED_PACKAGES_FOR_UPLOAD_AVATAR_FEAT = [
  "premium",
  "commerical",
  "trial",
  "premiumPlus",
];

const UserInfoBox = ({ toggleUserInfo }) => {
  const selectedConversation = useSelector(getSelectedConversation);
  const allAgentsInConversation = selectedConversation.conversation.agentsIds;
  const lastAgentInConvsId =
    allAgentsInConversation?.[allAgentsInConversation.length - 1];

  const lastPageAddress = getDecodedURL(selectedConversation?.user?.lastPage);
  const teamId = selectedConversation.conversation?.teamId;
  const teams = useSelector(getAllTeams);
  const agent = useSelector(getAgent);
  const allAgents = useSelector(getAgents);
  const container = useSelector(getContainer);
  const roadmapData = useSelector(getData);
  const isSmallDevice = useMediaQuery("(max-width: 650px)");
  const [showBlockUserModal, setShowBlockUserModal] = useState(false);
  const [selectedBlockOption, setSelectedBlockOption] = useState("0");
  const lastOperatorInConversation =
    lastAgentInConvsId &&
    allAgents?.find((agent) => agent.id === lastAgentInConvsId);

  const [userInfo, setUSerInfo] = useState(null);
  const [copyText, setCopyText] = useState(null);
  const [showConfirmUnblockModal, setShowConfirmUnBlockModal] = useState(false);
  const [errorObject, setErrorObject] = useState({});
  const { userRoadmapEnabled } = container;

  const [editingUsrInfo, setEditingUserInfo] = useState({
    userName: {
      value: "",
    },
    about: {
      value: "",
    },
    email: {
      status: false,
      value: "",
    },
    phone: {
      status: false,
      value: "",
    },
  });

  const [editUserInfoNote, setEditUserInfoNote] = useState(false);
  const userNoteTextareaRef = useRef(null);
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();
  const blockStatus = selectedConversation?.user?.blockStatus;
  const isUserBlocked = !!blockStatus;
  const shouldShowAvatarProgress =
    selectedConversation?.user?.avatarProgress &&
    selectedConversation?.user?.avatarProgress !== null;
  const selectedConversationTeam = teams.find((item) => item.id === teamId);
  const convType = selectedConversation?.conversation?.convType;

  const hasUploadAvatarPermission =
    ALLOWED_PACKAGES_FOR_UPLOAD_AVATAR_FEAT.includes(container?.package?.type);

  const dispatch = useDispatch();
  const isUserNameEditing = editingUsrInfo.userName.value !== userInfo?.name;

  const getUserData = () => {
    const userEmail = selectedConversation.user?.email;
    const emailString = Array.isArray(userEmail) ? userEmail[0] : userEmail;
    const emailValue = getEmailValue(emailString);

    setUSerInfo({
      ...selectedConversation.user,
      email: emailValue,
    });

    setEditingUserInfo({
      userName: {
        value: selectedConversation.user?.name,
      },
      about: {
        value: selectedConversation.user?.about,
      },
      email: {
        status: false,
        value: "",
      },
      phone: {
        status: false,
        value: "",
      },
    });
  };

  useEffect(() => {
    if (selectedConversation) {
      getUserData();
    }

    if (editUserInfoNote) {
      setEditUserInfoNote(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedConversation]);

  // adjusting usernote textarea focus and height
  useEffect(() => {
    const userNoteElement = userNoteTextareaRef.current;
    const userNoteElementScrollHeight = userNoteElement?.scrollHeight;

    if (!userNoteElement) return;

    // if content height is more than max height
    if (userNoteElementScrollHeight > USER_NOTE_ELEMENT_MAX_HEIGHT) {
      userNoteElement.style.height = `${USER_NOTE_ELEMENT_MAX_HEIGHT}px`;
    } else {
      userNoteElement.style.height = `${userNoteElementScrollHeight}px`;
    }

    // move cursor to the bottom of textarea
    userNoteElement.scrollTop = userNoteElement.scrollHeight;

    if (editUserInfoNote) {
      userNoteElement?.focus();
      userNoteElement.selectionStart = userNoteElement.value.length;
      userNoteElement.selectionEnd = userNoteElement.value.length;
    }
  }, [editUserInfoNote]);

  const setEditUserFiled = (editingField, editingStatus) => {
    setEditingUserInfo({
      ...editingUsrInfo,
      [editingField]: {
        value: "",
        status: editingStatus,
      },
    });
  };

  const setEditAgentFiled = (editingField, editingStatus) => {
    // setEditingAgetInfo({
    //   ...editingUsrInfo,
    //   [editingField]: {
    //     value: "",
    //     status: editingStatus,
    //   },
    // });
    // toast.error("این ویژگی فعلا فعال نیست");
  };

  const editUser = (field) => {
    let formData = {
      about: field === "about" ? editingUsrInfo.about.value : userInfo.about,
      name: field === "name" ? editingUsrInfo.userName.value : userInfo.name,
      email: field === "email" ? editingUsrInfo.email.value : userInfo.email,
      phone: field === "phone" ? editingUsrInfo.phone.value : userInfo.phone,
      id: userInfo.id,
      other: true,
    };

    dispatch(
      updateUserInfo({
        data: formData,
        convType,
      })
    );
  };

  const setUserInfo = (name, value) => {
    setEditingUserInfo(() => {
      return {
        ...editingUsrInfo,
        [name]: {
          ...editingUsrInfo[name],
          value,
        },
      };
    });
  };

  const handleKeyDown = (e) => {
    if (!e || (e && e.key === "Enter" && !e.shiftKey)) {
      editUser("about");
      setEditUserInfoNote(false);
    }
  };

  const handleResetNameValue = () => {
    setUserInfo("userName", userInfo?.name);
  };

  const handleUserInfoNoteCancelBtnClick = () => {
    setUserInfo("about", userInfo.about);
    setEditUserInfoNote(false);
  };

  const handleUserInfoNoteEditBtnClick = () => {
    setEditUserInfoNote(true);
  };

  const handleUserInfoNoteSubmitBtnClick = () => {
    editUser("about");
    setEditUserInfoNote(false);
  };

  const handleClickUserInfoNoteInput = () => {
    setEditUserInfoNote(true);
  };

  const handleClickUnBlockBtn = () => setShowConfirmUnBlockModal(true);

  const handleUploadAvatar = (fileObj) => {
    const selectedFile = verifyFileToOpen(fileObj);
    dispatch(updateUserAvatarStart(selectedFile));
  };

  /**
   * checks fields validation
   * @param {string} fieldName
   *
   * @returns Obj - reuturns object with fieldName key and error text of that field
   */
  const getFieldValidationObj = (fieldName) => {
    const errors = {};

    if (fieldName === "email" && !isValidEmail(editingUsrInfo.email.value)) {
      const text = "فرمت ایمیل صحیح نمیباشد";
      toast.warning(text);
      errors[fieldName] = text;
    }

    if (fieldName === "phone" && !isValidMobile(editingUsrInfo.phone.value)) {
      const text = "فرمت شماره موبایل صحیح نمیباشد";
      toast.warning(text);
      errors[fieldName] = text;
    }

    return errors;
  };

  const handleEditUserFieldConfirm = (fieldName, isAgent) => {
    const errorObj = getFieldValidationObj(fieldName);
    setErrorObject(errorObj);

    if (Object.keys(errorObj).length) {
      return;
    }

    if (isAgent) {
      setEditAgentFiled(fieldName, false);
    } else {
      editUser(fieldName);
    }

    setEditUserFiled(fieldName, false);
  };

  const handleDiscardEditChanges = (fieldName, isAgent) => {
    if (isAgent) {
      setEditAgentFiled(fieldName, false);
    } else {
      setEditUserFiled(fieldName, false);
    }

    setErrorObject({});
  };

  let copyToClipBoard = useCopyToClipboard(copyText);

  useEffect(() => {
    if (copyText || copyText === "") {
      copyToClipBoard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copyText]);

  const getUserInfoNoteInputValue = () => {
    const editingValue = editingUsrInfo.about.value;

    return editingValue;
  };

  const getBlockTimeSpanText = (start, end, forever = false) => {
    if (forever) {
      return `تا همیشه`;
    }

    const texts = [];

    const diffObject = getElapsedTime(start, end, "day");

    if (diffObject.days) {
      texts.push(`${diffObject.days} روز`);
    }

    if (diffObject.hours) {
      texts.push(`${diffObject.hours} ساعت`);
    }

    const finalText = texts.join(" و ");

    return `تا ${finalText} دیگر`;
  };

  const renderUserInfoNote = () => {
    if (editUserInfoNote) {
      return (
        <div className="conv__userinfo__card__note__input">
          <textarea
            onKeyDown={(e) => handleKeyDown(e)}
            onChange={(e) => setUserInfo("about", e.target.value)}
            value={getUserInfoNoteInputValue()}
            type="text"
            ref={userNoteTextareaRef}
            placeholder={t("DESCRIPTION_PH")}
            autoFocus
          />
        </div>
      );
    }

    return (
      <div
        onClick={handleClickUserInfoNoteInput}
        className="conv__userinfo__card__note__inner"
      >
        <div className="conv__userinfo__card__note__inner__box flex-ai-c">
          <div className="conv__userinfo__card__note__inner__box__text">
            {userInfo.about || t("DESCRIPTION_PH")}
          </div>
        </div>
      </div>
    );
  };

  const renderUserInfoNoteActionIcons = () => {
    if (editUserInfoNote) {
      return (
        <div className="actions flex flex-jc-e flex-columngap-8">
          <div
            onClick={handleUserInfoNoteSubmitBtnClick}
            className="actions__confirm"
            data-tool-tip-top={t("CONFIRM")}
          />
          <div
            onClick={handleUserInfoNoteCancelBtnClick}
            className="actions__reject no-margin"
            data-tool-tip-top={t("CANCEL")}
          />
        </div>
      );
    }
    return (
      <div className="actions flex flex-jc-e flex-columngap-8">
        <div
          onClick={handleUserInfoNoteEditBtnClick}
          className="actions__edit flex flex-ai-c"
          data-tool-tip-bottom-right={t("EIDT")}
        >
          <EditIconComponent className="actions__edit__for__notes__icon" />
        </div>
      </div>
    );
  };

  const renderProgressBar = (
    <ProgressBar
      progress={selectedConversation?.user?.avatarProgress || 0}
      trackWidth={5}
      indicatorWidth={5}
    />
  );

  const renderBlockDetails = () => {
    const now = new Date();
    const blockEndTime = new Date(blockStatus.end);
    const isBlockedForever = blockStatus.forever;

    return (
      <div className={styles.block_user__details}>
        <span className={styles.block_user__details__red_label}>
          بلاک شده :{" "}
        </span>
        <span>{getBlockTimeSpanText(now, blockEndTime, isBlockedForever)}</span>
        <button
          className={clsx(styles.unblock_btn, "btn-primary")}
          onClick={handleClickUnBlockBtn}
        >
          <span>لغو</span>
        </button>
      </div>
    );
  };

  const handleBlockUserBtnClick = (e) => {
    e.stopPropagation();
    setShowBlockUserModal(true);
  };

  const handleConfirmUnblock = () => {
    const userId = userInfo?.id;
    const ip = userInfo?.ip;

    if (userId) {
      dispatch(unblockUserStart({ userId, ip }));
    }
  };

  const getTotalTimeSpent = () => {
    const { userId, pages } = roadmapData || {};
    const dataExistAnduserIdTheSame = pages?.length && userId === userInfo?.id;

    return dataExistAnduserIdTheSame
      ? getFormatedTotalFromTimeElapsedObject(
          getElapsedTime(
            new Date(0),
            new Date(getTotalElapsedTimeInMs(roadmapData?.pages))
          )
        )
      : 0;
  };

  return (
    Object.keys(agent).length > 0 &&
    Object.keys(container).length > 0 && (
      <>
        <ConfirmModal
          showModal={showConfirmUnblockModal}
          text={t("CONFIRM_BLOCK_TEXT")}
          setShowModal={setShowConfirmUnBlockModal}
          handleConfirm={handleConfirmUnblock}
        />
        {userInfo && selectedConversation && (
          <>
            <div className={styles.header}>
              <div className="flex flex-ai-c flex-columngap-8">
                <img
                  alt="user_info"
                  className="conv__userinfo__card__close"
                  onClick={toggleUserInfo}
                  src={closeIcon}
                />
                <p className={styles.profile_info_text}>{t("USER_INFO")}</p>
              </div>

              {isUserBlocked ? (
                renderBlockDetails()
              ) : (
                <button
                  onClick={handleBlockUserBtnClick}
                  data-tool-tip-bottom-right={t("BLACK_LIST")}
                  className={`outline_grey_btn send-to-black-list no-margin ${
                    !isSmallDevice ? "btn-dark" : ""
                  }`}
                >
                  <BlockConversationIconComponent className="header_mobile_menu_item block_conv" />

                  <span className="header_desktop_menu_item">
                    {t("BLACK_LIST")}
                  </span>
                </button>
              )}

              {showBlockUserModal && (
                <BlockUserModal
                  selectedBlockOption={selectedBlockOption}
                  setSelectedBlockOption={setSelectedBlockOption}
                  setShowBlockUserModal={setShowBlockUserModal}
                  showBlockUserModal={showBlockUserModal}
                />
              )}
            </div>

            <div className={clsx(styles.profile_avatar_name, "flex flex-ai-s")}>
              <UserAvatar
                acceptedFormats={"image/gif, image/jpeg, image/png"}
                avatar={userInfo?.avatar}
                handleUploadAvatar={
                  hasUploadAvatarPermission ? handleUploadAvatar : undefined
                }
                renderProgress={renderProgressBar}
                showProgress={shouldShowAvatarProgress}
              />

              <div className="conv__userinfo__card__info__header__text">
                <div className="conv__userinfo__card__info__header__text__title">
                  <div className="title__editbox flex flex-column">
                    <div className="title__editbox__title">
                      <input
                        onChange={(e) =>
                          setUserInfo("userName", e.target.value)
                        }
                        value={
                          editingUsrInfo.userName.value
                            ? editingUsrInfo.userName.value
                            : // TODO: in some places user name assigned to "name" or "fullName" attribute
                              // this inconsistency should be fixed.
                              userInfo.name || userInfo.fullName || ""
                        }
                        type="text"
                      />
                    </div>

                    {!!isUserNameEditing ? (
                      <div
                        data-show={isUserNameEditing}
                        className="title__editbox__actions flex flex-ai-c"
                      >
                        <div
                          onClick={() => {
                            editUser("name");
                          }}
                          className="title__editbox__actions__save btn btn-primary btn-xsmall"
                        >
                          {t("SAVE")}
                        </div>
                        <div
                          onClick={handleResetNameValue}
                          className="title__editbox__actions__cancel btn btn-cancel btn-xsmall"
                        >
                          {t("CANCEL")}
                        </div>
                      </div>
                    ) : (
                      !!lastPageAddress && (
                        <a
                          href={lastPageAddress}
                          target="_blank"
                          rel="noreferrer"
                          className={styles.origin}
                        >
                          {lastPageAddress}
                        </a>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="conv__userinfo__card">
              {["email", "phone"].map((item) => (
                <div
                  key={item}
                  className="conv__userinfo__card__info__fields__inner__row flex flex-ai-c"
                >
                  {editingUsrInfo[item].status ? (
                    <EditingField
                      type={item}
                      editInfo={editingUsrInfo}
                      userInfo={userInfo}
                      errorObject={errorObject}
                      setUserInfo={setUserInfo}
                      onConfirm={handleEditUserFieldConfirm}
                      onDiscard={handleDiscardEditChanges}
                    />
                  ) : (
                    <ContentField
                      type={item}
                      userInfo={userInfo}
                      selectedConversation={selectedConversation}
                      setEditUserFiled={setEditUserFiled}
                      setCopyText={setCopyText}
                    />
                  )}
                </div>
              ))}
            </div>

            <div className="conv__userinfo__card__note__container notes-section">
              <div className="flex flex-ai-c conv__userinfo__card__note__title conv__userinfo__card__title conv__userinfo__card__info__fields__inner__row notes_title_wrapper">
                <div className="flex flex-ai-c flex-columngap-8">
                  <img src={NoteIcon} className="note_icon" alt="NoteIcon" />
                  <h3 className="notes_title">{t("NOTES")}</h3>
                </div>
                {renderUserInfoNoteActionIcons()}
              </div>

              <div className="conv__userinfo__card__note">
                {renderUserInfoNote()}
              </div>
            </div>

            <UserDetailsBox
              userInfo={userInfo}
              departmentName={selectedConversationTeam?.title}
              totalTimeSpent={getTotalTimeSpent()}
              lastOperatorInConversation={lastOperatorInConversation}
              userRoadmapEnabled={userRoadmapEnabled}
            />
          </>
        )}
      </>
    )
  );
};

export default UserInfoBox;
